import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { createEditorSession } from 'actions/editor';

import _ from 'lodash';
import cx from 'classnames';
import { Frame } from 'scenejs';
import { useEditorSession } from 'components/Editor/hooks/useEditorSession'

import { LIVE_ELEMENT_CONTAINER } from "constants/widgetTypes";

import { EditorContext } from '../../index';
import { Property } from '../../components/properties/';
import { BrandThemeManager, Widgets } from '@paperflite-marketing/cleverstory-commons';
import { BreakLiveElementDialog, EditLiveElementDialog } from 'components/Editor/components/liveElements';

import { HOTSPOT } from 'constants/widgetTypes';

import styles from './liveElements.module.scss';


const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

const LiveElementsWidgetComponent = function ({ widgetProps, widgetRef, className, style, children }) {
  const dispatch = useDispatch();

  const ref = widgetRef;

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const id = _.get(widgetProps, 'uid');
  const liveElementEditorSession = useEditorSession(`editors_live_element_${id}`);
  const margin = _.get(widgetProps, 'properties.desktop.margin', 0);
  const type = _.get(widgetProps, 'type');
  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));
  const widgets = useSelector(state => {
    const widgets = _.get(state, `${liveElementEditorSession.id}.present.widgets`) || [];
    return widgets.filter(item => item.type === LIVE_ELEMENT_CONTAINER);
  });
  const menuChild = widgetProps.children?.filter(
    child => child.type === 'cleverstory.v2.widgets.menu'
  );
  const livePresent = useSelector(state => _.get(state, `${liveElementEditorSession.id}.present.widgets`) || []);
  const matches = livePresent.some(item => {
    const isMatchingUid = item.type === 'cleverstory.v2.widgets.menu';
    const isStretched = item.properties[breakpoint]?.stretched === true;
    if (isMatchingUid && isStretched) {
      return true;
    }
    return isMatchingUid && isStretched;
  });
  const [widgetContextState, setWidgetContextState] = useState({
    selector: ``
  });

  const widgetStyle = {
    ...style,
    ...(matches && {
      marginLeft: 0,
      width: `calc(var(--editor-width) - 2 * ${margin}px) !important`,
      left: `calc((100% - var(--editor-width)) / 2) !important`,
    }),
  }

  useEffect(() => {
    initialiseEditor();
  }, [])

  const initialiseEditor = () => {
    const initialState = {
      widgets: widgetProps.children,
      entityType: 'LIVE_ELEMENT'
    };

    dispatch(createEditorSession(liveElementEditorSession.id, initialState));
    setWidgetContextState({
      imageCDN: IMAGE_CDN_ENDPOINT,
      shouldZoom: true,
      selector: `editors_live_element_${id}.present`
    })
  }

  return (
    <div id={id}
      ref={ref}
      className={cx(className, styles.liveElement, 'cs_live_element', {
        [styles.mobile]: breakpoint === 'mobile'
      })}
      data-widget-id={id}
      data-widget-type={type}
      data-container={false}
      data-selectable={true}
      style={widgetStyle}
    >
      <div className={styles.overlay}></div>
      
      <BrandThemeManager className={`#${id} .cs_text_widget`} themes={widgetProps.themes} />
      {widgets.length > 0 &&
      <Widgets.Context.Provider value={widgetContextState}>
        <Widgets.FormContext.Provider value={{ error: {} }}>
          {widgets.filter(item => item.type === LIVE_ELEMENT_CONTAINER).map((widget, index) => {
            return <Widgets.Widget key={widget.uid} widgetProps={widget} breakpoint={breakpoint} />
          })}
        </Widgets.FormContext.Provider>
      </Widgets.Context.Provider>
      } 
      {widgets.length === 0 && 
        <div className={styles.elementDeleted}>
          <i className={cx("cleverstory-broken", styles.icon)} />
          <span className={styles.label}>Element Deleted</span>
        </div>  
      }
    </div >
  )
}

const liveElementsWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'widgetRef'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

const LiveElementsWidget = React.memo(LiveElementsWidgetComponent, liveElementsWidgetEquals);

const LiveElementDesktopAction = (props) => {
  const [view, setView] = useState(null);

  const editorContext = React.useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const id = _.get(props, 'uid');
  
  const editable = useSelector((state) => {
    return _.get(state, 'users.me.id') === _.get(props, 'content.createdBy.id');
  });

  return (
    <>
      {props.content && editable &&
        <Property.Action className={styles.iconButton} tooltip='Edit live element' onClick={() => setView('editLiveElement')}>
          <i className={'cleverstory-edit'} />
        </Property.Action>
      }
      
      {props.content && 
        <Property.Action className={styles.iconButton} tooltip='Break live element' onClick={() => setView('breakLiveElement')}>
          <i className={'cleverstory-break-live-element'} />
        </Property.Action>
      }

      <Property.Action onClick={() => { window.open(`${process.env.REACT_APP_CLEVERSTORY_SUPPORT}`, '_blank') }} tooltip='Help' className={styles.iconButton}>
        <i className={'cleverstory-help'} />
      </Property.Action>

      {view === 'breakLiveElement' &&
        <BreakLiveElementDialog
          editorSession={editorSession}
          widget={props}
          onCancel={() => {
            setView(null);
          }}
        />
      }

      {view === 'editLiveElement' &&
        <EditLiveElementDialog
          editorSession={editorSession}
          widget={props}
          onCancel={() => {
            setView(null);
          }}
        />
      }
    </>
  );
}
let answer = [];
LiveElementsWidget.moveableConfig = (editorSession, widget) => {
  if (widget !== "cleverstory.v2.widgets.liveElement") {
    answer = widget;
  }
  const hasMenuType = answer.children?.some(
  child => child.type === 'cleverstory.v2.widgets.menu') || false;
  return {
    draggable: true,
    resizable: false,
    rotatable: true,
    selectable: true,
    cloneable: true,
    deletable: true,
    renderDirections: [],
    onDrag: hasMenuType ? (layout) => {
      const frame = new Frame(layout);
      const translate = frame.get("transform", "translate");
      const values = _.split(translate, ",");
      var y = parseInt(values[1]);
      y = Math.max(0, y);
      const newTranslate = `0px, ${y}px`;
      frame.set("transform", "translate", newTranslate);
      return frame.get();
    } : undefined,
    onResize: (widget, layout, breakpoint) => {
      const frame = new Frame(layout);
      frame.set('width', 'auto');
      frame.set('height', 'auto');
      return frame.get();
    },
    onReparent: (widget, parent) => {
      var parentElement = parent ? document.getElementById(parent) : null;
      if (parentElement && parentElement.getAttribute('data-widget-type') === HOTSPOT) {
        return false;
      }

      return true;
    }
  }
}

LiveElementsWidget.actions = (editor, breakpoint, props) => {
  return (
    <LiveElementDesktopAction
      editor={editor}
      breakpoint={breakpoint}
      {...props}
    />
  );
}

LiveElementsWidget.processRequest = (widget) => {
  const updated = _.omit(widget, 'children');

  return {
    ...updated,
    content: _.get(widget, 'content.id'),
  };
}

export { LiveElementsWidget }